<template>
    <navigation />

    <promo-header />

    <section class="section section-blue">

        <div class="container">

            <div class="row">

                <div class="col-lg-8">

                    <h2 class="mb-4">
                        Colossians
                    </h2>

                    <h5>Week 1 – Firm Faith</h5>
                    Text: Colossians 1:1-23
                    <p>
                        Aim: To teach that those God has rescued must continue in their faith,
                        living with Jesus as their supreme Lord and all-sufficient saviour.
                    </p>

                    <h5>Week 2 – Faith and Love</h5>
                    Text: Colossians 1:24-2:5
                    <p>
                        Aim: To teach that our goal as Christians is to become mature in faith,
                        wisdom and love for Jesus and to help others to do the same.
                    </p>

                    <h5>Week 3 – Full Faith</h5>
                    Text: Colossians 2:6-23
                    <p>
                        Aim: To teach that when we live differently as Christians by serving
                        others we imitate Jesus, glorify God and witness to unbelievers.
                    </p>

                    <h5>Week 4 – Faith in Action</h5>
                    Text: Colossians 3:1-4:1
                    <p>
                        Aim: To teach that Christians must live in a way that radically reflects
                        their spiritual transformation from death to life by dying to sin and imitating Jesus, their Lord.
                    </p>

                    <h5>Week 5 – Faithful Workers</h5>
                    Text: Colossians 4:2-18
                    <p>
                        Aim: To teach that Christians are called to share in gospel work by praying
                        for the ministry of others, witnessing personally to unbelievers and being united with other Christians.
                    </p>

                </div>

                <div class="offset-lg-1 col">

                    <promo-sidebar />

                </div>

            </div>

        </div>

    </section>

    <site-footer />
</template>

<script >
import Navigation from "../partials/Navigation.vue";
import SiteFooter from "../partials/SiteFooter.vue";
import PromoHeader from "../partials/PromoHeader.vue";
import PromoSidebar from "../partials/PromoSidebar.vue";

export default {
    name: "Colossians",

    components: {
        PromoSidebar,
        PromoHeader,
        Navigation,
        SiteFooter,
    },

    head() {
        return {
            title: `${this.$app.appName} - Colossians`,
            meta: [
                {
                    name: 'description',
                    content: "To teach that those God has rescued must continue in their faith",
                },
            ],
        };
    },
};
</script>
